import client from "./client";
export const createJoinRequest = (communityId, joinRequestMessage) => client.post("/requests/create", { communityId, joinRequestMessage });
export const getAllJoinRequests = () => client.get("/requests/all");
export const approveJoinRequest = (id) => client.put(`/requests/${id}/approve`);
export const rejectJoinRequest = (id) => client.put(`/requests/${id}/reject`);
export const getUserJoinRequests = (userId) => client.get(`/requests/user/${userId}`);
